import { color, spaces } from "emoreg/const";
import styled from "styled-components";

import { pillColor } from "./contants";
import { PillColor } from "./types";

type ContainerProps = { color?: PillColor; hasError?: boolean };

const Container = styled.div<ContainerProps>(
  {
    padding: `${spaces[8]} ${spaces[12]}`,
    borderRadius: 40,
    borderWidth: 0.5,
    borderStyle: "solid",
    "&:has(input:disabled)": {
      backgroundColor: color.grey.light,
      ...pillColor.grey,
    },
  },
  ({ color: _color = "grey" }) => ({
    "&:hover": {
      backgroundColor: pillColor[_color].hoverBackgroundColor,
    },
  }),
  ({ color: _color = "grey", hasError }) => {
    let borderColor = pillColor[_color].borderColor;
    if (hasError) borderColor = color.red.base;
    return { borderColor };
  }
);

Container.baseName = "InputPillContainer";

export const InputPillContainerStyle = Container;
